export class ApiBlobResponse {
  error: Blob;

  constructor(error: Blob) {
    this.error = error;
  }
}
